import React, { Component } from "react";
import styled from "styled-components";

export default class AddColumn extends Component {
  constructor(props) {
    super(props);
    this.addColumnHeaderRef = React.createRef();
  }

  componentDidMount() {
    this.props.context.props.store.addColumnStore.addColumnButtonPosition = this.addColumnHeaderRef.current;
    if (
      window.appStore.packStore.isNewlyCreatedSheet === true &&
      window.appStore.packStore.lastCreatedSheetId === ""
    ) {
      setTimeout(() => {
        this.addColumnHeaderRef.current.click();
        window.appStore.packStore.isNewlyCreatedSheet = false;
      }, 1);
    }
  }

  mouseEntered = () => {
    let array = Array.from(document.getElementsByClassName("addColumnCells"));
    array.forEach((cell) => {
      cell.classList.add("add-column-border");
    });
  };

  mouseleft = () => {
    let array = Array.from(document.getElementsByClassName("addColumnCells"));
    array.forEach((cell) => {
      cell.classList.remove("add-column-border");
    });
  };

  clickedHeader = (e) => {
    if (
      this.props?.context?.props?.view?.type == "table" &&
      this.props?.context?.props?.view?.list_id &&
      this.props?.context?.props?.view?.options?.main_list_id &&
      this.props?.context?.props?.view?.list_id !=
        this.props?.context?.props?.view?.options?.main_list_id
    ) {
      window.appStore.notificationStore.showNotification(
        "You can't add new field in this view.",
        "info"
      );
      return;
    }    
    this.props.api.stopEditing();
    this.props.context.props.store.addColumnStore.setAnchorEl(e.target);
    this.props.context.props.store.addColumnStore.setOpen(true);
    return;
  };

  render() {
    return (
      <div
        onClick={this.clickedHeader}
        onMouseEnter={this.mouseEntered}
        onMouseLeave={this.mouseleft}
      >
        <AddColumnHeaderDiv
          className="customHeaderLabel addColumnHeader"
          ref={this.addColumnHeaderRef}
          width={this.props.column.colDef?.width}
        >
          {this.props.displayName}
        </AddColumnHeaderDiv>
      </div>
    );
  }
}

const AddColumnHeaderDiv = styled.div`
  width: ${({ width }) => width}px;
`;
